import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@dispatch/ui/styles.css';
import './styles.css';
import { App } from './App.js';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Application root element was not found.');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
